import React from 'react';

// Option 1: pick an agent to shadow. Trainees can hop between agents freely —
// switching just re-points the listen leg; it never touches either agent's call.

// Display-only labels for backend agent statuses (raw values stay untouched).
const statusLabels = {
  available: 'Prêt',
  oncall:    'En appel',
  paused:    'Pause',
  online:    'En ligne',
  offline:   'Hors ligne',
};

export default function AgentList({ agents, listeningTo, onListen, onStop, disabled }) {
  const onCall = agents.filter(a => a.on_call);
  const idle   = agents.filter(a => !a.on_call);

  return (
    <div className="tr-panel">
      <div className="tr-panel-head">
        <h3>Agents</h3>
        <span className="tr-count">{agents.length}</span>
      </div>

      {agents.length === 0 && (
        <p className="tr-empty">Aucun agent n'est connecté présentement.</p>
      )}

      {onCall.length > 0 && <div className="tr-group-label">En appel</div>}
      {onCall.map(a => (
        <AgentRow key={a.id} agent={a} listeningTo={listeningTo}
                  onListen={onListen} onStop={onStop} disabled={disabled} />
      ))}

      {idle.length > 0 && <div className="tr-group-label">Disponibles</div>}
      {idle.map(a => (
        <AgentRow key={a.id} agent={a} listeningTo={listeningTo}
                  onListen={onListen} onStop={onStop} disabled={disabled} />
      ))}
    </div>
  );
}

function AgentRow({ agent, listeningTo, onListen, onStop, disabled }) {
  const active = listeningTo && listeningTo.id === agent.id;
  return (
    <div className={`tr-agent ${active ? 'is-active' : ''}`}>
      <div className="tr-agent-main">
        <div className="tr-agent-name">
          {agent.full_name || agent.username}
          {agent.on_call && <span className="tr-dot-live" title="En appel" />}
        </div>
        <div className="tr-agent-meta">
          ext {agent.extension}
          {agent.campaign_name ? ` · ${agent.campaign_name}` : ''}
          {agent.on_call ? ' · en appel' : ` · ${statusLabels[agent.status] || agent.status}`}
        </div>
      </div>
      {active ? (
        <button className="tr-btn tr-btn-stop" onClick={onStop}>Arrêter</button>
      ) : (
        <button className="tr-btn tr-btn-listen" disabled={disabled}
                onClick={() => onListen(agent)}>Écouter</button>
      )}
    </div>
  );
}
